/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Row, Col } from "react-bootstrap";
import * as homePageActions from "../../actions/homePageActions";
import Slider from "react-slick";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { Link, useNavigate, useParams } from "react-router-dom";
import Moment from "moment";
import { imgPath } from "../../utils/imagePath";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { getDatabase, ref, set, get, child } from "firebase/database";
import useResponsive from "../Home/Hooks/useMobile";
import PropTypes from "prop-types";

const Index = (props) => {

  const { actions, community, isAuth, userInfo, setting } = props;

  const [disabled, setDisabled] = useState(false);
  const [room, setRoom] = useState({ roomname: "" });
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [communityDetail, setCommunityDetail] = useState([]);
  const siteName = setting?.name?.trim() || "Community Details";
  const groupName = communityDetail?.group_name?.trim() || "Community";

  useEffect(() => {
    if (!communityDetail) return;

    window.scrollTo(0, 0);

    const title = communityDetail?.meta_title
      ? communityDetail.meta_title
      : `${siteName} | ${groupName}`;

    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && communityDetail?.meta_description) {
      metaDesc.setAttribute("content", communityDetail.meta_description);
    }
  }, [siteName, communityDetail?.group_name, communityDetail?.meta_title, communityDetail?.meta_description]);

  const { slug } = useParams();
  const history = useNavigate();
  const { isMobile, isTablet } = useResponsive();

  let slidesToShow = 3;

  if (isMobile) {
    slidesToShow = 1;
  } else if (isTablet) {
    slidesToShow = 2;
  }

  const communities = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow,
  };

  const getOrganizaionData = (page = 1) => {
    agent
      .get(API.LOAD_COMMUNITY + "/getCommunityDetails/" + slug, {})
      .then((res) => {
        setCommunityDetail(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const joinGroupDetail = async (e, community_id, community_slug) => {
    e.preventDefault();
    globalThis.location = "/community-details/" + community_slug;
  };

  const joinExitGroup = async (e, community_id, community_slug) => {
    e.preventDefault();
    if (isAuth === false) {
      setPopupMessage(
        "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      setShowPopup(true);
      history(`/login`);
      return;
    }

    setLoading(true); // start loader

    try {
      let res;

      if (disabled) {
        // Exit group
        res = await agent.get(
          `${API.LOAD_COMMUNITY}/exitGroup/${community_id}/${userInfo.id}`
        );
      } else {
        // Join group
        res = await agent.get(
          `${API.LOAD_COMMUNITY}/joinGroup/${community_id}/${userInfo.id}`
        );
      }

      const message = res?.data?.message || "Record has been updated successfully.";

      // Show popup
      setPopupMessage(message);
      setShowPopup(true);

      // Optionally refresh data
      getOrganizaionData();
    } catch (err) {
      console.error("Error in joinExitGroup:", err);
      setPopupMessage(
        err.response?.data?.message ||
        err.message ||
        "Something went wrong. Please try again."
      );
      setShowPopup(true);
    } finally {
      setLoading(false); // stop loader
    }
  };

  useEffect(() => {
    if (!communityDetail.group_users) return;

    for (const user of communityDetail.group_users) {
      if (user.id === userInfo.id) {
        setDisabled(true);
        break;
      }
    }
  }, [communityDetail.group_users, userInfo.id]);


  useEffect(() => {
    getOrganizaionData();
    actions.loadLeaderData(20);
    actions.loadCommunityData(20);
  }, [actions, slug]);

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  useEffect(() => {
    if (room.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [room, history]);

  const handleClickChat = async (item) => {
    if (!isAuth) {
      setPopupMessage(
        "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      setShowPopup(true);
      history(`/login`);
      return;
    }
    if (localStorage.isConfirmed !== "true") {
      setPopupMessage("Please Complete Your Profile First.");
      setShowPopup(true);
      return;
    }
    if (!disabled) {
      setPopupMessage("Please Join The Group First.");
      setShowPopup(true);
      return;
    }
    // Room name logic
    const roomUser =
      userInfo.id > item.id
        ? `${userInfo.id}_${item.id}`
        : `${item.id}_${userInfo.id}`;

    const time = Moment.utc().valueOf();
    // message object
    const message = {
      mentor_name: item.full_name,
      mentor_image: item.image,
      mentor_id: item.id,
      mentee_name: userInfo?.full_name,
      mentee_image: userInfo?.image,
      mentee_id: userInfo?.id,
      device_type: "Web",
      message: "",
      key: roomUser,
      role_id: userInfo.role_id,
      status: 0,
      time: Moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      epoch: -1 * time,
    };
    setRoom((prevRoom) => ({ ...prevRoom, roomname: roomUser }));
    // Initialize database
    const db = getDatabase();
    try {
      // Check and create mentor’s chat node if missing
      const mentorRef = ref(db, `users/${item.id}/${roomUser}`);
      const mentorSnapshot = await get(child(ref(db), `users/${item.id}/${roomUser}`));
      if (!mentorSnapshot.exists()) {
        await set(mentorRef, message);
      }
      // Check and create mentee’s chat node if missing
      const menteeRef = ref(db, `users/${userInfo.id}/${roomUser}`);
      const menteeSnapshot = await get(child(ref(db), `users/${userInfo.id}/${roomUser}`));
      if (!menteeSnapshot.exists()) {
        await set(menteeRef, message);
      }
    } catch (error) {
      console.error("Error creating chat room:", error);
    }
  };

  return (
    <div>
      <section className="community_section">
        <div className="content_inner">
          <img
            src={communityDetail.image}
            alt="women leadership mentoring"
            className="img-fluid back_img"
          />
        </div>
      </section>
      <section className="community_page_inner">
        <Container className="container">
          <div className="row_c d-flex">
            <div className="community_content">
              <h1 style={{ fontSize: '24px', fontWeight: '600' }} className="community_heading">
                vLookUp {communityDetail.group_name} Community
              </h1>
              <ul>
                <li>
                  <span>
                    <img
                      src={
                        imgPath + "iconc1.png"
                      }
                      className="img-fluid"
                      alt="online mentoring platform"
                    />
                  </span>{" "}
                  Admin
                </li>
                <li>
                  <span>
                    <img
                      src={
                        imgPath + "iconc2.png"
                      }
                      className="img-fluid"
                      alt="career coaching and mentoring"
                    />
                  </span>
                  {communityDetail.member_count} Members
                </li>
              </ul>
            </div>
            <div className="group_c d-flex align-items-center justify-content-center ms-auto">
              <button
                onClick={(e) => joinExitGroup(e, communityDetail.id, communityDetail.slug)}
                className="btn link_group ms-auto"
                disabled={loading}
              >
                {loading ? (
                  <span>Loading...</span>
                ) : (
                  <span>{disabled ? "Exit Group" : "Join Group"}</span>
                )}
              </button>
            </div>
          </div>

          <Row className="mt-4">
            <Col lg="8" md="7">
              <div className="whole_content">
                <div className="community_main_inner">
                  <h2 className="mb-3">About this group</h2>
                </div>

                <div className="community_main_inner mt-3 mt-md-5">
                  <div
                    dangerouslySetInnerHTML={prepareHtml(
                      communityDetail.description
                    )}
                  ></div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="5" className="mt-4 mt-md-0">
              <div className="sidebar_community overflow_custom_style">
                <div className="d-flex align-items-center heading justify-content-between mb-4">
                  <h2>Group Members ({communityDetail.member_count}) </h2>
                </div>

                {/* LIST */}
                {communityDetail.group_users?.map((item) => (
                  <div className="member_list" key={item.id}>
                    <ul>
                      <li className="d-flex align-items-center mb-3">
                        <div className="member_image">
                          {item.image && (
                            <img
                              src={item.image}
                              alt="career coaching for women"
                              className="img-fluid"
                            />
                          )}
                          {!item.image && (
                            <img
                              src={
                                imgPath +
                                "mentor_women_two.png"
                              }
                              className="img-fluid"
                              alt="career mentor consulting"
                            />
                          )}
                        </div>
                        <div className="member_detail ms-3">
                          <h3>{item.full_name}</h3>
                          <h4>{item.position}</h4>
                          <h4>{item.organization}</h4>
                          {userInfo.id != item.id && (
                            <button
                              className="link_btn btn btn_red"
                              onClick={() => handleClickChat(item)}
                            >
                              <img
                                src={
                                  imgPath +
                                  "msg.png"
                                }
                                alt="msg_icon"
                                className="me-2 bg-white"
                              />{""}
                              Send Message
                            </button>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                ))}
                {communityDetail.group_users?.length === 0 && (
                  <div className="text-center">No Joined User found.</div>
                )}
                {/* LIST */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="communities_sec">
        <Container>
          <div className="title text-center space-bottom position-relative">
            {"Suggested Groups"}
          </div>
          <Slider {...communities}>
            {
              // community &&
              // community.length &&
              community.map((item, key) => (
                <div key={item.id}>
                  <div className="communities_info">
                    <div>
                      <img
                        src={item.thumb_image}
                        alt="career mentor consulting"
                        className="w-100"
                      />
                      <div className="p-3">
                        <h4 className="m-0 heading pb-2">{item.group_name}</h4>
                        <p className="m-0">{item.title}</p>
                      </div>

                      <div className="mx-1 p-3 border-top d-flex align-items-center justify-content-between">
                        <div className="members_tag">
                          <i className="fas fa-users pe-2"></i>{" "}
                          {item.member_count}
                          {" Members"}
                        </div>

                        <Link
                          className="btn link_group ms-auto"
                          to=""
                          onClick={(e) => {
                            joinGroupDetail(e, item.id, item.slug);
                          }}
                        >
                          Join Group
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </Container>
      </section>
      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </div>
  );
};

Index.propTypes = {
  actions: PropTypes.shape({
    loadLeaderData: PropTypes.func.isRequired,
    loadCommunityData: PropTypes.func.isRequired,
  }).isRequired,
  community: PropTypes.array.isRequired,
  isAuth: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    full_name: PropTypes.string,
    image: PropTypes.string,
    role_id: PropTypes.string,
  }).isRequired,
  setting: PropTypes.object.isRequired,
  communityDetail: PropTypes.object.isRequired,
  setCommunityDetail: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    brand: state.brand,
    isAuth: state.isAuth,
    leaders: state.leaders,
    userInfo: state.userInfo,
    community: state.community,
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...homePageActions,
    },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
